import BulletList from '@tiptap/extension-bullet-list';

export const CustomBulletList = BulletList.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      listStyleType: {
        default: 'none',
        parseHTML: (element) => element.getAttribute('data-list-style') || element.style.listStyleType || 'none',
        renderHTML: (attributes) => {
          const style = attributes.listStyleType || 'none';
          return {
            'data-list-style': style,
            style: `list-style-type: ${style};`,
          };
        },
      },
    };
  },
});

export default CustomBulletList;
